import axios from "axios";
import $store from "../store";
import toLogin from "@libs/login";
import { VUE_APP_API_URL, normalizeApiUrl } from "@utils/index";
import { APP_CACHE_VERSION } from "@utils/cacheVersion";

const defaultOpt = { login: true };
function baseRequest(options) {
  let fwqs = $store.state.app.fwq;
  if (fwqs == "null" || fwqs == null || !fwqs) {
    fwqs = VUE_APP_API_URL;
  }

  console.log("服务器：" + fwqs);
  const instance = axios.create({
    baseURL: normalizeApiUrl(fwqs),
    timeout: 30000
  });

  const token = $store.state.app.token;
  const hasToken = token && token !== "null" && token !== "undefined";

  console.log("token" + token);
  const headers = Object.assign({}, options.headers || {});
  const method = String(options.method || "get").toLowerCase();
  if (method === "get" && options.cache !== true) {
    options.params = Object.assign({}, options.params || {}, {
      _appv: APP_CACHE_VERSION,
      _ts: Date.now()
    });
    headers["Cache-Control"] = "no-cache, no-store, max-age=0";
    headers["Pragma"] = "no-cache";
  }
  if (hasToken) {
    headers["token"] = token;
  }
  const isFormData = typeof FormData !== "undefined" && options.data instanceof FormData;
  if (!headers["Content-Type"] && !headers["content-type"] && !isFormData) {
    headers["Content-Type"] = "application/json ";
  }
  options.headers = headers;
  if (options.login && !hasToken) {
    toLogin();
    return Promise.reject({ msg: "未登录", toLogin: true });
  }
  //   instance.interceptors.reponse.use(res => {
  //    return res
  // }, err => {
  //    console.log(res.reponse)
  //     return Promise.reject(err)
  // })

  // console.log(options);
  return instance(options)
    .then(res => {
      // console.log(res);
      const data = res || {};
      return Promise.resolve(data, res);
    })
    .catch(err => {
      console.log("错误处理");
      if (!err.response) {
        return Promise.reject({ response: { data: { msg: "当前网络异常" } } });
      }
      if (err.response.status == 401) {
        if (options.login) {
          toLogin();
          return Promise.reject({ response: { data: { msg: "未登录" } } });
        }
        if (err.response.data && err.response.data.msg) {
          return Promise.reject(err);
        }
        return Promise.reject({ response: { data: { msg: "当前网络异常" } } });
      } else if (err.response.status == 429) {
        return Promise.reject({ response: { data: { msg: "操作频繁" } } });
      } else {
        if (err.response.data.msg) {
          return Promise.reject(err);
        }
        return Promise.reject({ response: { data: { msg: "当前网络异常" } } });
      }
    });
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, data, method }, defaultOpt, options)
    );
  };
  return request;
}, {});

["get", "delete", "head"].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({ url, params, method }, defaultOpt, options)
    );
  };
});

export default request;

